import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from 'notistack';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { getApiErrorMessage } from 'utils/apiErrors';
import * as businessActions from 'modules/Business/actions';
import { fetchBusiness } from 'modules/Business/actions';
import { saveAutoReloadPreference } from 'utils/businessAutoReload';
import AutoReloadPreference, {
  useAutoReloadPreference,
} from 'modules/Business/components/AutoReloadPreference';

const SetReload = ({ businessId, onClose }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const business = useSelector(state => state.business);
  const autoReloadPreference = useAutoReloadPreference(business, false);

  useEffect(() => {
    dispatch(fetchBusiness(businessId, true));
  }, [dispatch, businessId]);

  const handleSubmit = useCallback(() => {
    saveAutoReloadPreference(businessId, autoReloadPreference.reloadAmount)
      .then(() => {
        enqueueSnackbar(
          autoReloadPreference.enabled
            ? 'Auto reload updated.'
            : 'Auto reload turned off.',
          { variant: 'success' }
        );
        onClose();
        dispatch(businessActions.fetchBusiness(businessId, true));
      })
      .catch((requestError) => {
        enqueueSnackbar(
          getApiErrorMessage(
            requestError,
            'Couldn’t update auto reload. Please try again.'
          ),
          { variant: 'error' }
        );
      });
  }, [autoReloadPreference.enabled, autoReloadPreference.reloadAmount,
    dispatch, businessId, enqueueSnackbar, onClose]);

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle sx={{ marginBottom: 2 }}>
        Auto reload
      </DialogTitle>
      <DialogContent>
        <AutoReloadPreference preference={autoReloadPreference} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end">
          <Button color="primary" onClick={onClose}>Cancel</Button>
          <Button
            color="primary"
            disabled={!autoReloadPreference.isValid}
            variant="contained"
            onClick={handleSubmit}
          >
            Save changes
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SetReload;
